export const getInitialState = passedState => ({
  appState: {
    featureFlags: {},
    localization: {},
    requestMeta: {},
    session: {},
  },
  ...passedState,
});
